import React, { useState, useEffect, useRef } from "react";
import dots from "../assets/images/dots.svg";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { SpinnerCircular } from "spinners-react";
import Dropdown from "react-bootstrap/Dropdown";
import http from "../services/http";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from 'react-datepicker';

function PaymentHistory(props) {

  const [showModal, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const token = localStorage.getItem("xAuthToken");
  const [key, setKey] = useState("coach");
  const [loading, setLoading] = useState(true);
  const [coachPaymentDetails, setCoachPaymentDetails] = useState([]);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [available, setAvailable] = useState([]);
  const [monthAndYear, setMonthAndYear] = useState(new Date());

  useEffect(() => {
    CoachPaymentHistory();
  }, [monthAndYear]);

  const CoachPaymentHistory = async () => {
    setLoading(true);

    http
      .get(`api/admin/coach/payment-details?monthAndYear=${monthAndYear != null ? (monthAndYear.getMonth() + 1) +"/"+monthAndYear.getFullYear() : null}&token=${token}`)
      .then((res) => {
        setCoachPaymentDetails(res.data.data);
        setLastPageNumber(res.data.data.length % usersPerPage == 0 ? usersPerPage : res.data.data.length % usersPerPage);
        // setLastPageNumber(res.data.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.data.length / usersPerPage));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "coach":
        setLoading(true);

        http
        .get(`api/admin/coach/payment-details?monthAndYear=${monthAndYear != null ? (monthAndYear.getMonth() + 1) +"/"+monthAndYear.getFullYear() : null}&token=${token}`)
        .then((res) => {
            setCoachPaymentDetails(res.data.data);
            setLastPageNumber(res.data.data.length % usersPerPage == 0 ? usersPerPage : res.data.data.length % usersPerPage);
            // setLastPageNumber(res.data.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;
      //   case "Completed":
      //     setLoading(true);

      //     http
      //       .get(`public/admin/analyst/unavailable?token=${token}`)
      //       .then((res) => {
      //         setUnAvailable(res.data);
      //         setLastPageNumber(res.data.length % usersPerPage);
      //         setLastPage(Math.ceil(res.data.length / usersPerPage));
      //         setLoading(false);
      //       })
      //       .catch((error) => {
      //         console.log(error);
      //         setLoading(false);
      //       });
      //     break;

      //   case "Suspend":
      //     setLoading(true);

      //     http
      //       .get(`public/admin/analyst/suspend?token=${token}`)
      //       .then((res) => {
      //         setSuspend(res.data);
      //         setLastPageNumber(res.data.length % usersPerPage);
      //         setLastPage(Math.ceil(res.data.length / usersPerPage));
      //         setLoading(false);
      //       })
      //       .catch((error) => {
      //         console.log(error);
      //         setLoading(false);
      //       });
      //     break;
      default:
        setLoading(true);

        http
          .get(`api/admin/coach/payment-details?token=${token}`)
          .then((res) => {
            setCoachPaymentDetails(res.data.data);
            setLastPageNumber(res.data.data.length % usersPerPage == 0 ? usersPerPage : res.data.data.length % usersPerPage);
            // setLastPageNumber(res.data.data.length % usersPerPage);
            setLastPage(Math.ceil(res.data.data.length / usersPerPage));
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;
    }
  };



  const inputRef = useRef(null);

  const usersPerPage = 7;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCountCoach = Math.ceil(coachPaymentDetails.length / usersPerPage);
  const pageCountAvailable = Math.ceil(available.length / usersPerPage);
  const listCoach = coachPaymentDetails.length;
  const listAvailable = available.length;

  const handleMonthAndYear = (date) => {
    setMonthAndYear(date);
  };

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  <button
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link bt_none"
                  >
                    <i className="fa fa-align-left"></i>{" "}
                  </button>
                  <h1>Payment Details</h1>
                </div>
                <DropdownRight />
              </div>
            </header>
            <div className="dashbord_content">
              <div className="analysts-wraper-head">
                <div className="personal_and_bank_info Analysts_tabs">
                  {/* <div
                    className="map_btn tabs_google_meet"
                  >
                    {" "}
                    <button
                      style={{
                        marginTop: 40,
                        marginLeft: 42,
                       
                      }}
                      onClick={handleShow}
                      className="them_btn invite_btn"
                      type="button"
                      data-toggle="modal"
                      data-target="#Google_Meet"
                    >
                      Test
                    </button>{" "}
                   
                  </div> */}
                  <div className="map_btn " style={{marginTop:"60px" , textAlign:"end", marginBottom:"-120px"}}>  
                    <DatePicker
                      selected={monthAndYear}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      showFullMonthYearPicker
                      onChange={handleMonthAndYear}
                      placeholderText="Select month"
                      className="date-picker-wrapper"
                    />
                  </div>
                  <Tabs
                    activeKey={key}
                    onSelect={(k) => InProgress(k)}
                    style={{
                      alignItems: "center",
                      width: 320,
                      borderRadius: 5,
                      marginTop: 50,
                      backgroundColor: "#dee2e6",
                      padding: 10,
                    }}
                    defaultActiveKey="profile"
                    id="uncontrolled-tab-example"
                    className="mb-3 nav nav-pills border-bottom-0"
                  >
                    <Tab
                      eventKey="coach"
                      title="Coach"
                      style={{ marginTop: 10 }}
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-md">
                          <thead>
                            <tr>

                              <th scope="col" className=" ">
                                Coach Name
                              </th>
                              <th scope="col" className=" ">
                                Email
                              </th>
                              <th scope="col" className=" ">
                                Lease Date
                              </th>
                              <th scope="col" className=" ">
                                Lease Amount
                              </th>
                              <th scope="col" className=" ">
                                Evo Amount
                              </th>
                              <th scope="col" className=" ">
                                Paid Amount
                              </th>
                              <th scope="col" className="text-center">
                                Paid Status
                              </th>
                              <th scope="col" className="">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <div
                                style={{
                                  position: "absolute",
                                  marginTop: 250,
                                  backgroundColor: "#ffffffc2",
                                  marginLeft: 580,

                                  backgroundBlendMode: "overlay",
                                  zIndex: 100,
                                }}
                              >
                                <SpinnerCircular size="15%" />
                              </div>
                            ) : (
                              <>
                                {coachPaymentDetails
                                  .slice(
                                    pagesVisited,
                                    pagesVisited + usersPerPage
                                  )
                                  ?.map((item) => (
                                    <tr data-id={item.id}>

                                      <td style={{wordBreak: "break-all"}}>
                                        {item.name}
                                      </td>
                                      <td style={{wordBreak: "break-all"}}>
                                        {item.email}
                                      </td>
                                      <td>{moment(item.lease_amount_created_at).format('DD MMM, YYYY')}</td>
                                      <td>${item.lease_amount}</td>
                                      <td>
                                        ${item.evo_amount}
                                      </td>
                                      <td>
                                        {item.total_paid_amount == null ? '-' : '$' + '' + item.total_paid_amount}
                                      </td>
                                      <td className="text-center">
                                        <span style={{ color: item.is_paid === 0 ? "red" : "green", fontWeight: "bolder" }}> {item.is_paid === 0 ? "Pending" : "Completed"}</span>
                                      </td>
                                      <td class="text-center">
                                        <div class="dropdown wraper_btn">
                                          <Link
                                            to={`/evo-history/${item.id}`}
                                            state={{
                                              id: item.id,
                                            }}
                                            style={{ width: 10 }}
                                          >
                                            <img src={dots} className="img-fulid" style={{ width: 25 }} />
                                          </Link>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </>
                            )}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {listCoach != 0 ? (pageNumber === pageCountCoach - 1 ? (pagesVisited + 1 + '-' + (pagesVisited + lastPageNumber)) : (pagesVisited + 1 + '-' + (pagesVisited + usersPerPage))) : 0} out of{" "}
                              {listCoach} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountCoach}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                              forcePage={pageNumber}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>

                    <Tab
                      eventKey="Progress"
                      title="Analyst"
                      style={{ marginTop: 40 }}
                      disabled
                    >
                      <div className="table_vedio_upload dashbord_table     mb_30 mb-0">
                        <table className="table table-borderless table-responsive-xl">
                          <thead>
                            <tr>

                              <th scope="col" className="  ">
                                Analyst ID
                              </th>
                              <th scope="col" className=" ">
                                Analyst Name
                              </th>
                              <th scope="col" className=" ">
                                Email
                              </th>
                              <th scope="col" className=" ">
                                Cell Number
                              </th>
                              <th scope="col" className=" ">
                                Level
                              </th>
                              <th scope="col" className="  text-center">
                                Status
                              </th>
                              <th scope="col" className="  ">
                                {" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {available
                              .slice(pagesVisited, pagesVisited + usersPerPage)
                              ?.map((item) => (
                                <tr>

                                  <td className="pl_25">{item.id} </td>
                                  <td>
                                    {" "}
                                    {item.firstname} {item.lastname}
                                  </td>
                                  <td style={{ wordBreak: "break-all" }}>
                                    {item.email}
                                  </td>
                                  <td>{item.phone}</td>
                                  <td>
                                    {item.level ? item.level : "Beginner"}
                                  </td>
                                  <td>
                                    <div className="btn_wraper d-flex justify-content-center  ">
                                      <div className="btn_Subscribed">
                                        {" "}
                                        <button
                                          type="button"

                                        >

                                        </button>{" "}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="dropdown wraper_btn">

                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="pagination">
                          <div className="paginateText">
                            <p className="text-table-show">
                              {" "}
                              Showing{" "}
                              {
                                available.slice(
                                  pagesVisited,
                                  pagesVisited + usersPerPage
                                ).length
                              }{" "}
                              out of {listAvailable} entries
                            </p>
                          </div>
                          <div className="reactPaginate">
                            <ReactPaginate
                              previousLabel={"<<"}
                              nextLabel={">>"}
                              pageCount={pageCountAvailable}
                              onPageChange={changePage}
                              containerClassName={"paginationBttns"}
                              previousLinkClassName={"previousBttn"}
                              nextLinkClassName={"nextBttn"}
                              disabledClassName={"paginationDisabled"}
                              activeClassName={"paginationActive"}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default PaymentHistory;
